import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { HeaderModule } from './app/core/header/header.module';
import { CoreModule } from './app/core/core.module';
import { HomeModule } from './app/modules/main/pages/home/home.module';
import { MainModule } from './app/modules/main/main.module';
import { ErrorHandlerModule } from './app/core/error-handler.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AppRoutingModule } from './app/app-routing.module';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { errorHandlerFactory } from './app/core/providers/error-monitor.provider';
import { MobileAppService } from './app/core/services/mobile-app.service';
import { GooleAnalyticsEventsService } from './app/core/services/goole-analytics-events.service';
import { BrowserHelper } from 'src/app/core/helpers/browser-helper';
import { CookieService } from 'ngx-cookie-service';
import { ErrorInterceptor } from './app/core/helpers/error-inerceptor';
import { AuthInterceptor } from './app/core/helpers/auth-interceptor';
import { AuthService } from './app/core/services/auth.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { register } from 'swiper/element/bundle';
register();
import 'hammerjs';
if (environment.production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, NgIdleKeepaliveModule.forRoot(), ErrorHandlerModule.forRoot(), MainModule, HomeModule, CoreModule, HeaderModule),
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        AuthService,
        AuthInterceptor,
        ErrorInterceptor,
        CookieService,
        BrowserHelper,
        GooleAnalyticsEventsService,
        MobileAppService,
        { provide: ErrorHandler, useFactory: errorHandlerFactory },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
  .catch(err => console.error(err));
